import { z } from '../zod.js';

export const DashboardUrlField = z.url().meta({
  description:
    'The Checkout Page dashboard page for this record. Actions the MCP cannot perform, such as cancel, refund, resend or transfer, are done on that page.',
});
